module.exports = __webpack_public_path__ + "img/shipping-tax-split.069c50f7.svg";